import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const user = {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setUserInfo({ commit }, info) {
      commit('SET_USER_INFO', info)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
}

export default new Vuex.Store({
  modules: {
    user
  }
})